import { getShoppingCart } from "src/model/services/cart.service";
import React, { useEffect } from "react";
import { ROUTE_PATHS } from "./utils/constants";

export function CartProvider({ children }: any) {
  useEffect(() => { 
    if(!(window.location.pathname.includes(ROUTE_PATHS.CART) || window.location.pathname.includes(ROUTE_PATHS.CHECKOUT)))
    getShoppingCart()
  });
  return <>{children}</>;
}
